"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Layouts = require("layouts");
var React = require("react");
var Snippets = require("snippets");
var SubscribePageTemplate = /** @class */ (function (_super) {
    __extends(SubscribePageTemplate, _super);
    function SubscribePageTemplate(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            subscribe: _this.props.data.section.pagesubscribe
        };
        return _this;
    }
    SubscribePageTemplate.prototype.render = function () {
        var page = this.props.data.page;
        var subscribe = this.state.subscribe;
        return (React.createElement(Layouts.Theme, __assign({}, this.props),
            React.createElement(React.Fragment, null,
                subscribe && subscribe.settings.desktopBanner ? (React.createElement(Snippets.Container, { width: "full", className: "" },
                    React.createElement("div", { className: "relative md:max-h-24 overflow-hidden text-" + subscribe.settings.contentColour },
                        subscribe.settings.desktopBanner ? (React.createElement("div", { className: "relative md:h-24 h-14" },
                            React.createElement(Snippets.Image, { className: "bg-cover bg-center absolute pin hidden md:block", src: subscribe.settings.desktopBanner }),
                            React.createElement(Snippets.Image, { className: "block md:hidden", src: subscribe.settings.mobileBanner ? subscribe.settings.mobileBanner : subscribe.settings.desktopBanner }))) : null,
                        React.createElement("div", { className: "max-w-xl mx-auto flex items-center absolute pin z-10 mlg:px-11 text-" + subscribe.settings.contentColour },
                            React.createElement(Snippets.Heading, { size: "h2", tag: "h1", className: "font-extrabold lg:px-11 px-4 md:text-48 text-xmd" }, page.title ? page.title : "Subscribe"))))) : (React.createElement("div", { className: "content-placeholder", style: { height: "240px" } })),
                React.createElement(Snippets.Container, { tag: "section", className: "flex items-center justify-center py-2-4 mlg:px-11 md:px-2-4 px-1-6", width: "xl" },
                    React.createElement("div", { className: "w-full" },
                        React.createElement("div", { className: "md:w-1/3 w-full text-center mx-auto md:pt-4" },
                            !subscribe.settings.title ? (React.createElement(Snippets.Heading, { size: "h4", tag: "h1", className: "uppercase font-medium uppercase" }, page.title)) : null,
                            React.createElement(Snippets.SubscribeForm, __assign({}, this.props, { enabled: true, className: "", title: subscribe.settings.title, content: subscribe.settings.content, sucsesstitle: subscribe.settings.sucsesstitle, sucsesscontent: subscribe.settings.sucsesscontent, shoplink: subscribe.settings.shopurl }))))),
                React.createElement(Snippets.Container, { tag: "section", width: "sm", className: "md:pb-2-4" }, page.content ? React.createElement(Snippets.RichText, { size: "small" }, page.content) : null))));
    };
    return SubscribePageTemplate;
}(React.Component));
exports.SubscribePageTemplate = SubscribePageTemplate;
